<template>
  <!-- 富文本 -->
  <div class="content" id="container">
    <div v-if="content" v-html="content"></div>
    <div class="no-msg" v-else>
      <img src="@/assets/images/system/no-data.png" alt="" />
      <p>暂无应用介绍~</p>
    </div>
  </div>
</template>
<script>
import { getContentBrief } from '@/service/system/rich-text'
export default {
  data() {
    return {
      content: ''
    }
  },
  created() {
    this.initContent()
  },
  mounted() {},
  methods: {
    initContent() {
      getContentBrief(this.$route.query.id).then((res) => {
        this.content = res.content
        this.$nextTick(() => {
          // 获取资讯全部video 播放当前video暂停其他video
          let videoContent = document.getElementsByTagName('video')
          for (let i = 0; i < videoContent.length; i++) {
            videoContent[i].addEventListener('play', function () {
              var vs = document.getElementsByTagName('video')
              for (let j = 0; j < vs.length; j++) {
                console.log('1')
                if (vs[j] !== this) vs[j].pause()
              }
            })
          }
          // 获取资讯全部图片
          let imgsContent = document.getElementsByTagName('img')
          let newContentImgs = []
          let allImgsContent = []
          if (imgsContent && imgsContent.length > 0) {
            for (let i = 0; i < imgsContent.length; i++) {
              if (imgsContent[i].parentNode.nodeName != 'A') {
                newContentImgs.push(imgsContent[i].getAttribute('src'))
                allImgsContent.push(imgsContent[i])
              }
            }
            for (let i = 0; i < allImgsContent.length; i++) {
              let _Index = i
              allImgsContent[i].onclick = function () {
                if (window.SFApi.isInClient()) {
                  console.log(_Index, '_Index', newContentImgs)
                  window.SFApi.media.viewImages(_Index, newContentImgs)
                }
              }
            }
          }
        })
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  width 100%
  height: 100%;
  overflow-x hidden
  overflow-y: scroll;
  background: #F2F8FF;
  -webkit-overflow-scrolling: touch
  position relative
  padding 30px
  /deep/ p
    font-size: 34px;
    color: #666666;
    span
      // font-size: 34px;
      color: #666666;
  /deep/ img
    max-width 100%
    width auto !important
    display block
    margin 20px auto
  /deep/ video
    width 100% !important
    max-height 500px
    display block
    margin 20px auto
  .no-msg
    width 100%
    overflow hidden
    img
      width 150px
      overflow hidden
      display block
      margin 260px auto 10px auto
    p
      text-align center
      font-size 28px
      color #ccc
</style>
